import React from "react";

import { Grid } from "@/components/Grid";
import { Pricing, IPricing } from "@/containers/Pricing";
import { PricingProvider } from "@/containers/Pricing/state/context";

type IProps = IPricing & JSX.IntrinsicElements["div"];

export const PricingSection: React.FC<IProps> = props => {
  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        padding: 0,
      }}
      wrapperStyle={{ position: "relative" }}
      id="PricingSection"
    >
      <PricingProvider>
        <Pricing {...props} />
      </PricingProvider>
    </Grid>
  );
};
